import React from 'react';
import { t } from 'i18next';
import moment from 'moment';
import { Card, Col, Row } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import VisitHeader from '../visit-header';
import VisitDetails from '../visit-details';
import { AccordianComponent } from '../../../../components/Accordian';

export const RenderVisitList = ({ visit, total, currentPage, onPageChange, perPage }) => {

	const totalPages = Math.ceil(total / perPage);
	const paginationItems = [];

	for (let number = 1; number <= totalPages; number++) {
		paginationItems.push(
			<Pagination.Item key={number} active={number === currentPage} onClick={() => onPageChange(number)}>
				{number}
			</Pagination.Item>
		);
	}

	return visit.length > 0 ? (
		<>
			{visit.map((v) => (
				<Card key={v.id}>
					<AccordianComponent eventKey={v.id} headerContent={
						<Row>
							<Col xs={12} className="w-100">
								<h4 className="text-primary">{moment(v.created_at).format('DD-MM-YYYY')}</h4>
							</Col>
						</Row>
					}>
						<Row className='mt-4'>
							<Col className='col-12'>
								<Card text='dark' bg='white'>
									<VisitHeader visitId={v.id} isPastVisit={true} />
									<VisitDetails visit={v} />
								</Card>
							</Col>
						</Row>
					</AccordianComponent>
				</Card>
			))}
			<div className="d-flex  flex-end justify-content-end align-items-center mt-4">
				<Pagination className="mb-0">
					{paginationItems}
				</Pagination>
			</div>
		</>
	) : (
		<Row className='mt-4'>
			<Col>
				<Card text='dark' bg='white'>
					<h5 className='text-center m-3'>{t('VISIT.NO_VISITS')}</h5>
				</Card>
			</Col>
		</Row>
	);
};